
// Widget Scripts
import mainFeatureSlide from './js/widgets/mainFeatureSlide.js';
import logoCards from './js/widgets/logoCards.js';
import sponsors from './js/widgets/sponsors.js';
import multiScheduleFeature from './js/widgets/multiScheduleFeature.js';

import seoWidget from './js/widgets/seoWidget.js';
import videoWidget from './js/widgets/videoWidget.js';

import * as socialNetworkWidgetDefault from './js/widgets/socialNetworkWidgetDefault';
import * as socialNetworkWidgetSecond from './js/widgets/socialNetworkWidgetSecond';

// Custom Theme Scripts
import './js/localjs.js';
import './js/subpagesWidgets.js';

// Widgets only for homepage
if (window.location.pathname === '/') {
  $(document).ready(function () {
    mainFeatureSlide();
    seoWidget();

    $(window).load(function () {
      videoWidget();
      socialNetworkWidgetDefault.instafeed(true);
      socialNetworkWidgetDefault.facebookfeed(true);
      socialNetworkWidgetSecond.facebookfeedSecondary(true);
    })

  });
}

// Widgets for all pages
$(document).ready(function () {
  logoCards();
  sponsors();
  multiScheduleFeature();

});
